import React from "react";
import exterior_023 from "./images/exterior_023.jpg";
import pool_030 from "./images/pool_030.jpg";
import pool_019 from "./images/pool_019.jpg";
import exterior_015 from "./images/exterior_015.jpg";
import common_001 from "./images/common_001.jpg";
import common_023 from "./images/common_023.jpg";
import exterior_013 from "./images/exterior_013.jpg";
import exterior_006 from "./images/exterior_006.jpg";
import exterior_017 from "./images/exterior_017.jpg";
import room_002 from "./images/room_002.jpg";
import room_004 from "./images/room_004.jpg";
import room_011 from "./images/room_011.jpg";
import room_008 from "./images/room_008.jpg";
import room_009 from "./images/room_009.jpg";
import room_024 from "./images/room_024.jpg";
import common_022 from "./images/common_022.jpg";
import common_021 from "./images/common_021.jpg";
import room_003 from "./images/room_003.jpg";
import { FaInstagram } from "react-icons/fa";
import { useState } from "react";

function Gallery() {
  try {
    const [activeFilter, setActiveFilter] = React.useState("all");

    const filters = [
      { id: "all", label: "All" },
      { id: "interior", label: "Interior" },
      { id: "exterior", label: "Exterior" },
      { id: "pool", label: "Pool" },
      { id: "events", label: "Events" },
    ];

    const galleries = [
      {
        src: exterior_023,
        category: "exterior",
        alt: "Villa Exterior View",
      },
      {
        src: exterior_006,
        category: "exterior",
        alt: "Villa Exterior View",
      },
      {
        src: exterior_013,
        category: "exterior",
        alt: "Villa Exterior View",
      },
      {
        src: exterior_017,
        category: "exterior",
        alt: "Villa Exterior View",
      },
      {
        src: room_002,
        category: "interior",
        alt: "Villa Interior View",
      },
      {
        src: room_003,
        category: "interior",
        alt: "Villa Interior View",
      },
      {
        src: room_004,
        category: "interior",
        alt: "Villa Interior View",
      },
      {
        src: room_011,
        category: "interior",
        alt: "Bedroom",
      },
      {
        src: room_024,
        category: "exterior",
        alt: "Villa Exterior View",
      },
      {
        src: room_008,
        category: "interior",
        alt: "Bedroom",
      },
      {
        src: room_009,
        category: "interior",
        alt: "Bedroom",
      },
      {
        src: common_021,
        category: "events",
        alt: "Lounge Area",
      },

      {
        src: pool_030,
        category: "pool",
        alt: "Swimming Pool",
      },
      {
        src: pool_019,
        category: "pool",
        alt: "Swimming Pool",
      },
      {
        src: common_022,
        category: "events",
        alt: "Kitchen",
      },
      {
        src: common_023,
        category: "events",
        alt: "Dinning",
      },
      {
        src: exterior_015,
        category: "exterior",
        alt: "Garden View",
      },
      {
        src: common_001,
        category: "events",
        alt: "Gaming",
      },
    ];

    const galleryImages = [
      {
        src: exterior_023,
        category: "exterior",
        alt: "Villa Exterior View",
      },
      {
        src: pool_030,
        category: "pool",
        alt: "Swimming Pool",
      },
      {
        src: room_003,
        category: "interior",
        alt: "Villa Exterior View",
      },
      {
        src: room_002,
        category: "interior",
        alt: "Villa Interior View",
      },

      {
        src: exterior_015,
        category: "exterior",
        alt: "Garden View",
      },
      {
        src: common_001,
        category: "events",
        alt: "Gaming",
      },
    ];

    const filteredImages =
      activeFilter === "all"
        ? galleryImages
        : galleries.filter((img) => img.category === activeFilter);

    // Modal state
    const [modalOpen, setModalOpen] = useState(false);
    const [modalIndex, setModalIndex] = useState(0);

    const openModal = (idx) => {
      setModalIndex(idx);
      setModalOpen(true);
    };
    const closeModal = () => setModalOpen(false);
    const showPrev = (e) => {
      e.stopPropagation();
      setModalIndex((prev) =>
        prev === 0 ? filteredImages.length - 1 : prev - 1
      );
    };
    const showNext = (e) => {
      e.stopPropagation();
      setModalIndex((prev) =>
        prev === filteredImages.length - 1 ? 0 : prev + 1
      );
    };

    return (
      <section
        className="section-padding bg-white px-4 sm:px-6 lg:px-8"
        data-name="gallery"
        data-file="components/Gallery.js"
      >
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-6">
              Gallery
            </h2>
            <p className="text-xl text-stone-600 max-w-2xl mx-auto">
              Explore the beauty and luxury of Angelo's Farm through our
              stunning photo gallery
            </p>
          </div>

          {/* Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {filters.map((filter) => (
              <button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                  activeFilter === filter.id
                    ? "bg-[#B86A4B] text-white shadow-lg"
                    : "bg-white text-[#B86A4B] hover:bg-[#B86A4B] hover:text-white border border-[#B86A4B]"
                }`}
              >
                {filter.label}
              </button>
            ))}
          </div>

          {/* Image Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredImages.map((image, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 cursor-pointer"
                onClick={() => openModal(index)}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4 text-white">
                    <p className="font-semibold">{image.alt}</p>
                    <p className="text-sm capitalize">{image.category}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Modal Popup */}
          {modalOpen && (
            <div
              className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm"
              onClick={closeModal}
            >
              <div
                className="relative max-w-5xl w-full mx-2 md:mx-8"
                style={{ minHeight: "70vh" }}
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  className="absolute top-2 right-2 text-white text-3xl font-bold z-10 bg-black/40 rounded-full px-3 py-1 hover:bg-black/70 transition"
                  onClick={closeModal}
                  aria-label="Close"
                >
                  &times;
                </button>
                <button
                  className="absolute left-2 top-1/2 -translate-y-1/2 text-white text-3xl font-bold z-10 bg-black/40 rounded-full px-3 py-1 hover:bg-black/70 transition"
                  onClick={showPrev}
                  aria-label="Previous"
                >
                  &#8592;
                </button>
                <img
                  src={filteredImages[modalIndex].src}
                  alt={filteredImages[modalIndex].alt}
                  className="w-full h-[60vh] md:h-[75vh] object-contain rounded-2xl shadow-2xl bg-white"
                  style={{ minHeight: "350px", maxHeight: "80vh" }}
                />
                <button
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-white text-3xl font-bold z-10 bg-black/40 rounded-full px-3 py-1 hover:bg-black/70 transition"
                  onClick={showNext}
                  aria-label="Next"
                >
                  &#8594;
                </button>
                <div className="text-center text-white mt-4">
                  <span className="font-semibold text-lg">
                    {filteredImages[modalIndex].alt}
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Instagram Link */}
          <div className="text-center mt-12">
            <p className="text-stone-600 mb-4">
              Follow us on Instagram for more updates
            </p>
            <a
              href="https://www.instagram.com/angelosfarm._/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-8 py-4 rounded-xl font-semibold transition-all duration-300 shadow-lg bg-[#B86A4B] text-white hover:bg-[#a0522d]"
            >
              <FaInstagram size={30} style={{ marginRight: "8px" }} />
              View Instagram
            </a>
          </div>
        </div>
      </section>
    );
  } catch (error) {
    console.error("Gallery component error:", error);
    return null;
  }
}

export default Gallery;
